import React from 'react';
import TermsContainer from '../../containers/ketentuan/TermsContainer';

const Terms = ({ query }) => (
  <TermsContainer query={query} />
);

export default Terms;
